module.exports = __webpack_public_path__ + "img/16.f58bca0b.webp";